/**
 * Third-party embeds for Experience tour, IMPROVE Live, and Launch booking.
 * Set URLs in env when tools are ready (Storylane/Navattic, Bookings/Calendly, etc.).
 */
export const EMBEDS = {
  /** Interactive product tour iframe src (Storylane, Navattic, Walnut, etc.) */
  tourUrl: process.env.VUE_APP_TOUR_EMBED_URL || '',
  /** IMPROVE Live registration / webinar booking URL */
  liveUrl: process.env.VUE_APP_LIVE_BOOKING_URL || '',
  /** Launch Programme session booking (Microsoft Bookings / Calendly) */
  launchBookingUrl: process.env.VUE_APP_LAUNCH_BOOKING_URL || '',
};

export function hasTourEmbed() {
  return !!EMBEDS.tourUrl;
}

export function hasLiveEmbed() {
  return !!EMBEDS.liveUrl;
}

export function hasLaunchBooking() {
  return !!EMBEDS.launchBookingUrl;
}
